import type { IconSvgObject } from './types';

const Pacman01Icon: IconSvgObject = [
  ["path", { d: "M22 12H21.991M18.009 12H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5119 7.5L10.5029 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 12C2 16.9706 6.02944 21 11 21C13.7947 21 16.2919 19.7262 17.9426 17.7275C18.2779 17.3216 18.1752 16.728 17.7572 16.408L13.037 12.794C12.5143 12.3937 12.5143 11.6063 13.037 11.206L17.7572 7.59199C18.1752 7.27197 18.2779 6.67837 17.9426 6.27249C16.2919 4.2738 13.7947 3 11 3C6.02944 3 2 7.02944 2 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Pacman01Icon;
